import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2026 Leo Amiri. Built with intention.</p>
    </footer>
  );
}
